import React from 'react';
import styles from '../Accordion.module.scss';
import { useAccordionContext } from '../context/AccordionContext';
// @ts-ignore
import classNames from 'classnames';

type AccordionHeaderPropsType = {
  index: number;
  children: React.ReactNode;
  className?: string;
  activeClass?: string;
};

const AccordionHeader = (props: AccordionHeaderPropsType) => {
  const { toggle, currentOpen, isOpen } = useAccordionContext();

  const handleClick = () => {
    if (toggle) {
      toggle(props.index);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      handleClick();
    }
  };

  return (
    <div
      className={classNames(
        styles.header,
        props.className,
        props.index === currentOpen && isOpen && `${styles.headerIsOpen} ${props.activeClass}`
      )}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      tabIndex={0}
    >
      {props.children}
    </div>
  );
};

export default AccordionHeader;
